import React, { useContext, useState } from 'react';
import { LanguageContext } from '../LanguageContext';
import config from '../config';
import MyMap from './Mapinteraction';

const Contact = () => {
  const { t } = useContext(LanguageContext);
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  // Ouvre l'application de messagerie avec le message pré-rempli
  const onSubmit = (e) => {
    e.preventDefault();
    const body = `${form.message}\n\n— ${t.contact.mailBodyFrom} ${form.name} (${form.email})`;
    const url =
      `mailto:${config.email}` +
      `?subject=${encodeURIComponent(form.subject)}` +
      `&body=${encodeURIComponent(body)}`;
    window.location.href = url;
  };

  return (
    <div className="page container">
      <header className="page__head">
        <h1>{t.contact.title}</h1>
        <p>{t.contact.intro}</p>
      </header>

      <div className="contact">
        <form className="form" onSubmit={onSubmit} data-aos="fade-up">
          <label>
            {t.contact.name}
            <input name="name" value={form.name} onChange={onChange} required autoComplete="name" />
          </label>
          <label>
            {t.contact.email}
            <input type="email" name="email" value={form.email} onChange={onChange} required autoComplete="email" />
          </label>
          <label>
            {t.contact.subject}
            <input name="subject" value={form.subject} onChange={onChange} required />
          </label>
          <label>
            {t.contact.message}
            <textarea name="message" rows="6" value={form.message} onChange={onChange} required />
          </label>
          <button type="submit" className="btn btn--dark">{t.contact.send}</button>
          <p className="form__hint">{t.contact.hint}</p>
        </form>

        <aside className="contact__info" data-aos="fade-up" data-aos-delay="150">
          <h3>{t.contact.directly}</h3>
          <dl>
            <dt>{t.contact.emailLabel}</dt>
            <dd><a href={`mailto:${config.email}`}>{config.email}</a></dd>
            {config.phone && (
              <>
                <dt>{t.contact.phoneLabel}</dt>
                <dd><a href={`tel:${config.phone.replace(/\s/g, '')}`}>{config.phone}</a></dd>
              </>
            )}
            <dt>{t.contact.addressLabel}</dt>
            <dd>{config.addressLine}, {config.city}</dd>
          </dl>
          <MyMap />
        </aside>
      </div>
    </div>
  );
};

export default Contact;
